export default class AdminsByCategoryAreaService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    return this.$http.get('/api/report/data_y_c_admin', {
      params: {
        chartType: 'area',
        ...params
      }
    }).then(r => r.data);
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-area/admins-by-category-area.service.js